import {HostListener, Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";
import {DialogModel} from "../../models/components/dialog.model";

@Injectable({
    providedIn: "root"
})
export class DialogService {
    public dialogContent = new Subject<DialogModel>();

    public get dialogObservable(): Observable<DialogModel> {
        return this.dialogContent.pipe(
            // distinctUntilChanged()
        );
    }

    public show(model: DialogModel): void {
        this.dialogContent.next(model);
    }

    public hide(): void {
        this.dialogContent.next(null);
    }

    public focus(): void {
        setTimeout(() => {
            const dialogElement = document.getElementById("dialogModal");
            if (!!dialogElement) {
                dialogElement.focus();
            }
        });
    }
}
